<template>
  <main class="admin-login">
    <form class="admin-login-card" @submit.prevent="submit">
      <h1>后台管理</h1>
      <p>管理首页文案、入口、一句话和音乐。</p>
      <label>
        用户名
        <input v-model.trim="form.username" autocomplete="username" placeholder="admin">
      </label>
      <label>
        密码
        <input v-model="form.password" type="password" autocomplete="current-password" placeholder="admin123">
      </label>
      <button type="submit" :disabled="loading">{{ loading ? '登录中' : '登录' }}</button>
      <span class="admin-error" v-if="error">{{ error }}</span>
    </form>
  </main>
</template>

<script>
import { login } from '../api/admin';

export default {
  name: 'AdminLogin',
  data() {
    return {
      loading: false,
      error: '',
      form: {
        username: 'admin',
        password: 'admin123'
      }
    };
  },
  methods: {
    submit() {
      this.loading = true;
      this.error = '';
      login(this.form)
        .then(data => {
          localStorage.setItem('adminToken', data.token);
          localStorage.setItem('adminName', data.nickname || data.username);
          this.$router.replace('/admin');
        })
        .catch(() => {
          this.error = '用户名或密码错误';
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
